import { useState, type FormEvent } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { authApi } from "../../api/auth";
import { DEFAULT_BRANDING } from "../../shared/branding";
import { AuthShell } from "../../shared/AuthShell";
import { errorMessage } from "../../shared/errors";
import { Alert, Button, Input } from "../../ui";

export function ResetPasswordPage() {
  const [search] = useSearchParams();
  const token = search.get("token") ?? "";
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await authApi.confirmReset({ token, new_password: password });
      setDone(true);
    } catch (err) {
      setError(errorMessage(err, "This reset link is invalid or has expired."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell branding={DEFAULT_BRANDING} title="Choose a new password">
      {done ? (
        <div className="flex flex-col gap-4">
          <Alert kind="success">
            Your password was changed. Other sessions were signed out.
          </Alert>
          <Link className="text-brand underline" to="/login">
            Sign in
          </Link>
        </div>
      ) : (
        <form
          onSubmit={submit}
          className="flex flex-col gap-4"
          aria-label="Reset password"
        >
          {error ? <Alert kind="error">{error}</Alert> : null}
          {!token ? (
            <Alert kind="error">This reset link is missing its token.</Alert>
          ) : null}
          <Input
            label="New password"
            type="password"
            autoComplete="new-password"
            required
            minLength={10}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button type="submit" loading={busy} disabled={!token}>
            Change password
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
